// Key values that are repeated a lot
import { defaultFieldLogic } from 'AppSrc/core/components/forms/form-base-components/data-structure/default-field-logic';
import {
  isStatusImplementation,
  isStatusCompleted,
} from 'AppSrc/core/crq/crq-statuses';
// import {
//   isUnsuccessfulStatusReason,
// } from 'AppSrc/core/crq/crq-status-reasons';
import { MOBILE, FIXED } from 'AppSrc/core/components/forms/value-dependency-constants';
import { getPostChangeType } from 'AppSrc/core/components/forms/form-types/completion-review/form-utility-functions';
import { CAUSE_AN_INCIDENT, CHANGE_REGRESSED } from 'AppSrc/core/components/forms/form-types/completion-review/form-definition/section-constants';
// form fields
import { changeFollowImplementationPlan } from './change-follow-implementation-plan';
import { deliverExpectedResults } from './deliver-expected-results';
import { changeCauseIncident } from './change-cause-incident';
import { completedWithinChangeWindowWithoutAdditionalImpacts } from './completed-within-change-window-without-additional-impacts';
import { changeRequestRegressed } from './change-request-regressed';
import { hasItBeenUpdated } from './has-it-been-updated';
import { enterIncidentReference } from './enter-incident-reference';
import { provideDetailsOfRegression } from './provide-details-of-regression';
// sub section titles
import { postChangeQuestionnaire } from './post-change-questionnaire';
import { postChangeReview } from './post-change-review';
import { paragraphBasedOnTheEngineer } from './paragraph-based-on-the-engineer';
import { paragraphPleaseComplete } from './paragraph-please-complete';

import { postChangeCommsSelector } from '../section-three/post-change-comms-selector';
// import { additionalImpact } from './additional-Impact';
import { mobilecompletedWithinChangeWindowWithoutAdditionalImpacts } from './mobile-completed-within-change-window';
import { fixedchangeFollowImplementationPlan } from './fixed-change-follow-implementation';

const updateValue = ({ network }) => (callBackParams) => {
  const {
    form,
    thisField,
    newValue,
  } = callBackParams;

  const {
    name,
  } = thisField;

  const {
    setValues,
    values,
    setFieldTouched,
  } = form;

  const postChangeType = getPostChangeType({
    network,
    values: {
      ...values,
      [name]: newValue,
    },
  });
  // gets the old values for all of the form and mixes in the new value
  const newValues = {
    ...values,
    [postChangeCommsSelector.id]: postChangeType,
    [name]: newValue,
  };

  // set the new form data with/without side affects
  setValues(newValues);

  setFieldTouched(name, true);
};

// callback for the form section to figure out what fields to render with conditional logic
const getSectionOneCurrentFields = ({
  values,
  network,
  readOnly,
  isOLO,
  formData,
} = {}) => {
  let enterIncidentShouldRender = false;
  let provideDetailShouldRender = false;
  // const { statusReason, status } = formData;
  // const isUnsuccessful = isUnsuccessfulStatusReason(statusReason, network);
  // const isCompleted = isStatusCompleted(status);
  // const isFailure = isUnsuccessful && isCompleted;

  if (values) {
    const { [CAUSE_AN_INCIDENT]: changeCauseIncidentValue, [CHANGE_REGRESSED]: changeRequestRegressedValue } = values;

    enterIncidentShouldRender = changeCauseIncidentValue ? changeCauseIncidentValue.includes('Yes') : false;
    provideDetailShouldRender = changeRequestRegressedValue ? changeRequestRegressedValue.includes('Yes') : false;
    if (network === 'fixed') {
      enterIncidentShouldRender = changeCauseIncidentValue ? changeCauseIncidentValue.includes('10') : false;
      provideDetailShouldRender = changeRequestRegressedValue ? changeRequestRegressedValue.includes('10') : false;
    }
  }
  const commonFieldLogic = {
    ...defaultFieldLogic,
    readOnly,
    updateValue: (formData && (isStatusImplementation(formData.status) || isStatusCompleted(formData.status))) ? updateValue({ network }) : null,
    shouldRender: !isOLO,
    shouldValidate: !isOLO,
    // OLO CRQ needs to set all answers to Unknown (This was prev requirement but during PCR enhancements only inventory updated is being sent as 30. This was done on 21st Feb)
    overwriteSubmit: {
      overwrite: isOLO,
      // overwriteValue: 'Unknown',
      overwriteValue: '30',
    },
  };

  const commonFields = [
    {
      ...commonFieldLogic,
      componentData: network === 'fixed' ? {
        ...fixedchangeFollowImplementationPlan,
      } : {
        ...changeFollowImplementationPlan,
      },
      // OLO CRQ needs to set all answers to happy or successful scenarios
      overwriteSubmit: {
        overwrite: isOLO,
        // overwriteValue: 'Unknown',
        overwriteValue: '10',
      },
    }, {
      ...commonFieldLogic,
      componentData: {
        ...deliverExpectedResults,
      },
      // OLO CRQ needs to set all answers to happy or successful scenarios
      overwriteSubmit: {
        overwrite: isOLO,
        // overwriteValue: 'Unknown',
        overwriteValue: '10',
      },
    }, {
      ...commonFieldLogic,
      componentData: {
        ...changeCauseIncident,
        shouldRender: true,
      },
      // OLO CRQ needs to set all answers to happy or successful scenarios
      overwriteSubmit: {
        overwrite: isOLO,
        // overwriteValue: 'Unknown',
        overwriteValue: '20',
      },
    }, {
      ...defaultFieldLogic,
      componentData: {
        ...enterIncidentReference,
      },
      shouldRender: enterIncidentShouldRender,
    }, {
      ...commonFieldLogic,
      componentData: network === 'fixed' ? {
        ...completedWithinChangeWindowWithoutAdditionalImpacts,
      } : { ...mobilecompletedWithinChangeWindowWithoutAdditionalImpacts },
      // OLO CRQ needs to set all answers to happy or successful scenarios
      overwriteSubmit: {
        overwrite: isOLO,
        // overwriteValue: 'Unknown',
        overwriteValue: '10',
      },
    },
  ];

  const commsfieldSection = [
    {
      ...commonFieldLogic,
      componentData: {
        ...changeRequestRegressed,
      },
    }, {
      ...defaultFieldLogic,
      componentData: {
        ...provideDetailsOfRegression,
      },
      shouldRender: provideDetailShouldRender,
    },
  ];

  const mobileFields = [
    {
      ...defaultFieldLogic,
      componentData: postChangeReview,
    }, {
      ...defaultFieldLogic,
      componentData: paragraphPleaseComplete,
    },
  ];

  const fixedFields = [
    {
      ...defaultFieldLogic,
      componentData: postChangeQuestionnaire,
    }, {
      ...defaultFieldLogic,
      componentData: paragraphBasedOnTheEngineer,
    },
  ];

  if (network === MOBILE) {
    mobileFields.push(...commonFields, ...commsfieldSection);
    return mobileFields;
  }
  if (network === FIXED) {
    fixedFields.push(...commonFields, {
      ...commonFieldLogic,
      componentData: {
        ...changeRequestRegressed,
      },
      // OLO CRQ needs to set all answers to happy or successful scenarios
      overwriteSubmit: {
        overwrite: isOLO,
        // overwriteValue: 'Unknown',
        overwriteValue: '20',
      },
    }, {
      ...defaultFieldLogic,
      componentData: {
        ...provideDetailsOfRegression,
      },
      shouldRender: provideDetailShouldRender,
    }, {
      ...commonFieldLogic,
      componentData: {
        ...hasItBeenUpdated,
      },
    });
    return fixedFields;
  }

  return [];
};

export {
  getSectionOneCurrentFields,
};
